import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import type { Permission } from '@genoma/shared';

import { useAuthStore } from '../stores/auth.store.ts';
import { useTranslate } from '../i18n/index.tsx';
import { Centered } from './Centered.tsx';

type Props = {
  children: ReactNode;
  permission?: Permission;
};

/**
 * Waits for the session check before deciding, so a signed-in user never sees
 * the sign-in screen flash on reload.
 */
export const ProtectedRoute = ({ children, permission }: Props) => {
  const status = useAuthStore((state) => state.status);
  const can = useAuthStore((state) => state.can);
  const t = useTranslate();

  if (status === 'loading') return <Centered>{t('common.loading')}</Centered>;
  if (status === 'anonymous') return <Navigate to="/acceso" replace />;
  if (permission && !can(permission)) return <Centered>{t('errors.forbidden')}</Centered>;

  return <>{children}</>;
};
